export enum MouseEventType {
  DoubleClick = 'dblclick',
  MouseDown = 'mousedown',
  MouseUp = 'mouseup',
  Wheel = 'wheel'
}
